import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedLocationId: localStorage.getItem('selectedLocationId') || null,
    locations: [],
    status: 'idle',
};

const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        setLocation(state, action) {
            state.selectedLocationId = action.payload;
            localStorage.setItem('selectedLocationId', action.payload);
        },
        setLocations(state, action) {
            state.locations = action.payload;
        },
        clearLocation(state) {
            state.selectedLocationId = null;
            localStorage.removeItem('selectedLocationId');
        },
    },
});

export const { setLocation, setLocations, clearLocation } = locationSlice.actions;
const locationReducer = locationSlice.reducer;

export default locationReducer;
